import "../styles/sidebar.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from "primereact/dialog";
import { useLayout } from '../Hooks/layout/useLayout.js';
import Content from './Content.jsx';
import { useCommon } from '../Hooks/Common/useCommon.js';
import CommanDialog from '../components/CommonCompo/CommanDialog/CommanDialog.js';
import { useRef, useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useNotification } from '../Hooks/Features/Notification/useNotification.js';
import Inbox from '../components/Notification/Inbox.jsx';
import _ from "underscore";
import Profile from "../components/Profile/Profile.jsx";
import CarouselImage from "../components/Layout/CarouselImage.jsx";
import { faThumbtack, faUser, faCamera, faSignOutAlt, faPalette, faMessage, faBars, faMobile, faGrip, faXmark, faMagnifyingGlass, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext.js';
import { ToastContext } from "../context/ToastContext.js";
import DownloadApp from "../components/Layout/DownloadApp.jsx";
import TaptikHistory from "../components/Employeedashboard/TaptikHistory.jsx";

const toastPositions = [
    { id: 1, name: "Top Right", position: "top-right" },
    { id: 2, name: "Top Left", position: "top-left" },
    { id: 3, name: "Bottom Right", position: "bottom-right" },
    { id: 4, name: "Bottom Left", position: "bottom-left" },
    { id: 5, name: "Top Center", position: "top-center" },
    { id: 6, name: "Bottom Center", position: "bottom-center" }
];

function DefaultLayout() {
    const profileIconRef = useRef(null);
    const profileDropdownRef = useRef(null);
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState({ theme: false, toast: false });

    const {
        resetSidebar, setSidebarOpen, getMyProfile, viewProfileDialog, setViewProfileDialog,
        handleLogout, visible, setVisible, viewProfile, setViewProfile, showNotification,
        setShowNotification, location, handleMenuItemClick,
        block, notifiData, setNotifiData, readData, dataFlag, getNotificationData,
        handleBlockUI, notificationCount, rowData, GetEmployeeAttandance, GetEmployeeAttandanceSummary,
        sidebarOpen, showTaptik, setShowTaptik, profileImage, carouselPopup, setCaroselPopup,
        isPinned, setIsPinned, sortableItems,
        appPopup, setAppPopup, feedBackData, myProfileData
    } = useLayout();

    const { checkPermission, getValuePermission } = useCommon();
    const platform = sessionStorage.getItem("platform");
    useNotification();
    const { theme, setTheme } = useTheme();
    const { setPosition, position } = useContext(ToastContext);

    const [openTabs, setOpenTabs] = useState([]);
    const [openSubTabs, setOpenSubTabs] = useState({});
    const [subTabsDropdownOpen, setSubTabsDropdownOpen] = useState(false);
    const [col3Search, setCol3Search] = useState("");
    const [isInitialized, setIsInitialized] = useState(false);
    const [hoveredMenu, setHoveredMenu] = useState(null);
    const [showMegaMenu, setShowMegaMenu] = useState(false);
    const [megaMenuSearch, setMegaMenuSearch] = useState("");
    const [collapsedSubmenus, setCollapsedSubmenus] = useState({});
    const [tabViewMode, setTabViewMode] = useState(() => {
        return localStorage.getItem('tabViewMode') || 'hierarchical';
    });
    const [sidebarSubmenuMode, setSidebarSubmenuMode] = useState(() => {
        return localStorage.getItem('sidebarSubmenuMode') || 'groupwise';
    });
    const [visitedPaths, setVisitedPaths] = useState(new Set([
        location === "/" ? "/employee-dashboard" : location
    ]));

    useEffect(() => {
        const handleModeChange = () => {
            setTabViewMode(localStorage.getItem('tabViewMode') || 'hierarchical');
        };
        const handleSubmenuModeChange = () => {
            setSidebarSubmenuMode(localStorage.getItem('sidebarSubmenuMode') || 'groupwise');
        };
        window.addEventListener('tabViewModeChanged', handleModeChange);
        window.addEventListener('sidebarSubmenuModeChanged', handleSubmenuModeChange);
        return () => {
            window.removeEventListener('tabViewModeChanged', handleModeChange);
            window.removeEventListener('sidebarSubmenuModeChanged', handleSubmenuModeChange);
        };
    }, []);

    const flatTabsContainerRef = useRef(null);
    const [hasScrollOverflow, setHasScrollOverflow] = useState(false);

    const checkScrollOverflow = () => {
        if (flatTabsContainerRef.current) {
            const hasOverflow = flatTabsContainerRef.current.scrollWidth > flatTabsContainerRef.current.clientWidth;
            setHasScrollOverflow(hasOverflow);
        }
    };

    const handleScrollTabs = (direction) => {
        if (flatTabsContainerRef.current) {
            const scrollAmount = 150;
            if (direction === 'left') {
                flatTabsContainerRef.current.scrollLeft -= scrollAmount;
            } else {
                flatTabsContainerRef.current.scrollLeft += scrollAmount;
            }
        }
    };

    useEffect(() => {
        if (tabViewMode === 'flat') {
            const timer = setTimeout(checkScrollOverflow, 100);
            window.addEventListener('resize', checkScrollOverflow);
            return () => {
                clearTimeout(timer);
                window.removeEventListener('resize', checkScrollOverflow);
            };
        }
    }, [tabViewMode, openTabs, openSubTabs]);

    // Handle Escape key to close Mega Menu
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setShowMegaMenu(false);
            }
        };
        if (showMegaMenu) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showMegaMenu]);

    // Click outside to close the sub-tab dropdown
    useEffect(() => {
        const handleClickOutsideDropdown = (e) => {
            if (!e.target.closest('.sk-sub-tab-dropdown-container')) {
                setSubTabsDropdownOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutsideDropdown);
        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    // Global listener to close PrimeReact dropdown panels when drawer is closed/applied
    useEffect(() => {
        const handleGlobalCaptureClick = (e) => {
            const target = e.target;
            if (!target) return;

            const isCloseBtn = target.closest('.sk-drawer-close-btn');
            const isOverlay = target.closest('.sk-drawer-overlay') && !target.closest('.sk-drawer-panel');
            const isApplyBtn = target.closest('.sk-drawer-footer button') || (target.tagName === 'BUTTON' && target.textContent && target.textContent.includes('Apply'));

            if (isCloseBtn || isOverlay || isApplyBtn) {
                if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
                setTimeout(() => {
                    const eventOptions = { bubbles: true, cancelable: true };
                    document.body.dispatchEvent(new MouseEvent('mousedown', eventOptions));
                    document.body.dispatchEvent(new MouseEvent('click', eventOptions));
                }, 0);
            }
        };

        document.addEventListener('click', handleGlobalCaptureClick, true);
        document.addEventListener('mousedown', handleGlobalCaptureClick, true);
        return () => {
            document.removeEventListener('click', handleGlobalCaptureClick, true);
            document.removeEventListener('mousedown', handleGlobalCaptureClick, true);
        };
    }, []);

    // Initialize openTabs and openSubTabs once when sortableItems are loaded
    useEffect(() => {
        if (!sortableItems || sortableItems.length === 0 || isInitialized) return;

        // 1. Initialize Main Module Tabs
        const savedPaths = localStorage.getItem('openTabs');
        let initialTabs = [];
        if (savedPaths) {
            try {
                const paths = JSON.parse(savedPaths);
                initialTabs = paths
                    .map(p => sortableItems.find(item => item.to === p))
                    .filter(Boolean);
            } catch (e) {
                console.error("Failed to parse openTabs", e);
            }
        }

        const activeOuterMenu = sortableItems.find(item =>
            location === item.to ||
            (item.checkPath && item.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)))
        );

        let mergedTabs = [...initialTabs];
        if (activeOuterMenu && !mergedTabs.some(t => t.to === activeOuterMenu.to)) {
            mergedTabs.push(activeOuterMenu);
        }

        if (mergedTabs.length === 0) {
            const dashboardTab = sortableItems.find(item => item.to === "/employee-dashboard");
            if (dashboardTab) {
                mergedTabs.push(dashboardTab);
            }
        }

        setOpenTabs(mergedTabs);
        localStorage.setItem('openTabs', JSON.stringify(mergedTabs.map(t => t.to)));

        // 2. Initialize Sub-Tabs
        const savedSubPaths = localStorage.getItem('openSubTabs');
        let initialSubTabs = {};
        if (savedSubPaths) {
            try {
                const parsed = JSON.parse(savedSubPaths);
                Object.keys(parsed).forEach(k => {
                    const outerMenu = sortableItems.find(item => item.to === k);
                    if (outerMenu && outerMenu.innerMenu) {
                        const subs = [];
                        parsed[k].forEach(p => {
                            for (const inner of outerMenu.innerMenu) {
                                if (inner.subMenu) {
                                    const sub = inner.subMenu.find(s => s.to === p);
                                    if (sub) {
                                        subs.push(sub);
                                        break;
                                    }
                                }
                                if (inner.to === p) {
                                    subs.push(inner);
                                    break;
                                }
                            }
                        });
                        initialSubTabs[k] = subs;
                    }
                });
            } catch (e) {
                console.error("Failed to parse openSubTabs", e);
            }
        }

        let activeSubItem = null;
        if (activeOuterMenu && activeOuterMenu.innerMenu) {
            for (const inner of activeOuterMenu.innerMenu) {
                if (inner.subMenu) {
                    const sub = inner.subMenu.find(s => location === s.to);
                    if (sub) {
                        activeSubItem = sub;
                        break;
                    }
                }
                if (location === inner.to) {
                    activeSubItem = inner;
                    break;
                }
            }
        }

        if (activeOuterMenu) {
            const outerKey = activeOuterMenu.to;
            if (!initialSubTabs[outerKey] || initialSubTabs[outerKey].length === 0) {
                const defaultSub = activeOuterMenu.innerMenu ? activeOuterMenu.innerMenu.find(inner => inner.isPermitted) : null;
                if (defaultSub) {
                    initialSubTabs[outerKey] = [defaultSub];
                }
            }
            if (activeSubItem && initialSubTabs[outerKey] && !initialSubTabs[outerKey].some(s => s.to === activeSubItem.to)) {
                initialSubTabs[outerKey].push(activeSubItem);
            }
        }

        setOpenSubTabs(initialSubTabs);
        const serializeSubObj = {};
        Object.keys(initialSubTabs).forEach(k => {
            serializeSubObj[k] = initialSubTabs[k].map(s => s.to);
        });
        localStorage.setItem('openSubTabs', JSON.stringify(serializeSubObj));

        setIsInitialized(true);
    }, [sortableItems, isInitialized, location]);

    // Handle adding new tab and sub-tab when location changes
    useEffect(() => {
        if (!isInitialized || !sortableItems || sortableItems.length === 0) return;

        const activeOuterMenu = sortableItems.find(item =>
            location === item.to ||
            (item.checkPath && item.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)))
        );

        if (activeOuterMenu) {
            // Add active main module to openTabs
            setOpenTabs(prevTabs => {
                if (prevTabs.some(t => t.to === activeOuterMenu.to)) {
                    return prevTabs;
                }
                const updated = [...prevTabs, activeOuterMenu];
                localStorage.setItem('openTabs', JSON.stringify(updated.map(t => t.to)));
                return updated;
            });

            // Find the active inner item or subMenu item
            let activeSubItem = null;
            if (activeOuterMenu.innerMenu) {
                for (const inner of activeOuterMenu.innerMenu) {
                    if (inner.subMenu) {
                        const sub = inner.subMenu.find(s => location === s.to);
                        if (sub) {
                            activeSubItem = sub;
                            break;
                        }
                    }
                    if (location === inner.to) {
                        activeSubItem = inner;
                        break;
                    }
                }
            }

            if (activeSubItem) {
                setOpenSubTabs(prev => {
                    const outerKey = activeOuterMenu.to;
                    const currentSubs = prev[outerKey] || [];
                    if (currentSubs.some(s => s.to === activeSubItem.to)) {
                        return prev;
                    }
                    const updatedSubs = [...currentSubs, activeSubItem];
                    const updatedObj = {
                        ...prev,
                        [outerKey]: updatedSubs
                    };
                    const serializeObj = {};
                    Object.keys(updatedObj).forEach(k => {
                        serializeObj[k] = updatedObj[k].map(s => s.to);
                    });
                    localStorage.setItem('openSubTabs', JSON.stringify(serializeObj));
                    return updatedObj;
                });
            }
        }
    }, [location, sortableItems, isInitialized]);


    const handleCloseTab = (tabToClose, e) => {
        e.stopPropagation();
        e.preventDefault();

        const newTabs = openTabs.filter(tab => tab.to !== tabToClose.to);
        setOpenTabs(newTabs);
        localStorage.setItem('openTabs', JSON.stringify(newTabs.map(t => t.to)));

        // Clean up open sub-tabs for this module
        const updatedSubTabs = { ...openSubTabs };
        delete updatedSubTabs[tabToClose.to];
        setOpenSubTabs(updatedSubTabs);
        const serializeSubObj = {};
        Object.keys(updatedSubTabs).forEach(k => {
            serializeSubObj[k] = updatedSubTabs[k].map(s => s.to);
        });
        localStorage.setItem('openSubTabs', JSON.stringify(serializeSubObj));

        // If the closed tab was the currently active tab, navigate away
        const isActive = location === tabToClose.to ||
            (tabToClose.checkPath && tabToClose.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)));

        if (isActive) {
            if (newTabs.length > 0) {
                const nextTab = newTabs[newTabs.length - 1];
                navigate(nextTab.to, { state: nextTab?.state });
            } else {
                navigate("/employee-dashboard");
            }
        }
    };

    const handleCloseSubTab = (outerTo, subToClose, e) => {
        e.stopPropagation();
        e.preventDefault();

        const currentSubs = openSubTabs[outerTo] || [];
        const newSubs = currentSubs.filter(sub => sub.to !== subToClose.to);

        const updatedObj = {
            ...openSubTabs,
            [outerTo]: newSubs
        };
        setOpenSubTabs(updatedObj);

        const serializeObj = {};
        Object.keys(updatedObj).forEach(k => {
            serializeObj[k] = updatedObj[k].map(s => s.to);
        });
        localStorage.setItem('openSubTabs', JSON.stringify(serializeObj));
        setVisitedPaths(prev => {
            const next = new Set(prev);
            next.delete(subToClose.to);
            return next;
        });

        // If the closed sub-tab was active, navigate to another
        const isActive = location === subToClose.to;

        if (newSubs.length === 0) {
            // Close the main Level 1 tab as well!
            const newTabs = openTabs.filter(tab => tab.to !== outerTo);
            setOpenTabs(newTabs);
            localStorage.setItem('openTabs', JSON.stringify(newTabs.map(t => t.to)));

            // Clean up open sub-tabs for this module
            setVisitedPaths(prev => {
                const next = new Set(prev);
                next.delete(outerTo);

                const parentTabConfig = openTabs.find(tab => tab.to === outerTo);
                if (parentTabConfig && parentTabConfig.innerMenu) {
                    parentTabConfig.innerMenu.forEach(inner => {
                        next.delete(inner.to);
                        if (inner.subMenu) {
                            inner.subMenu.forEach(sub => next.delete(sub.to));
                        }
                    });
                }
                return next;
            });
            const updatedSubTabs = { ...updatedObj };
            delete updatedSubTabs[outerTo];
            setOpenSubTabs(updatedSubTabs);
            const serializeSubObj = {};
            Object.keys(updatedSubTabs).forEach(k => {
                serializeSubObj[k] = updatedSubTabs[k].map(s => s.to);
            });
            localStorage.setItem('openSubTabs', JSON.stringify(serializeSubObj));

            if (isActive) {
                if (newTabs.length > 0) {
                    navigate(newTabs[newTabs.length - 1].to, { state: newTabs[newTabs.length - 1]?.state });
                } else {
                    navigate("/employee-dashboard");
                }
            }
        } else {
            if (isActive) {
                navigate(newSubs[newSubs.length - 1].to);
            }
        }
    };

    const handleTabClick = (tab, e) => {
        e.preventDefault();
        navigate(tab?.to, { state: tab?.state });
    };

    const handleMenuItemClickWithExpand = (value, e) => {
        handleMenuItemClick(value, e);
    };

    const handleSidebarMouseLeave = () => {
        if (!isPinned && window.innerWidth > 768) {
            setSidebarOpen(false);
        }
    };

    const togglePin = () => {
        setIsPinned(!isPinned);
    };

    // Helper to calculate initials from display name
    const getInitials = (name) => {
        if (!name) return "WJ";
        const parts = name.trim().split(/\s+/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return parts[0][0].toUpperCase();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                profileDropdownRef.current &&
                !profileDropdownRef.current.contains(event.target) &&
                profileIconRef.current &&
                !profileIconRef.current.contains(event.target)
            ) {
                setViewProfile(false);
                setShowMenu({ theme: false, toast: false })
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setViewProfile]);

    useEffect(() => {
        if (viewProfile && profileIconRef.current && profileDropdownRef.current) {
            const iconRect = profileIconRef.current.getBoundingClientRect();
            const dropdown = profileDropdownRef.current;
            dropdown.style.position = 'fixed';
            dropdown.style.top = `${iconRect.bottom + 5}px`;
            dropdown.style.right = `${window.innerWidth - iconRect.right}px`;
        }
    }, [viewProfile]);



    // Dynamic header title extraction based on current location matching active menu path
    const activeOuterMenu = sortableItems.find(item =>
        location === item.to ||
        (item.checkPath && item.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)))
    );

    // Find active sub-item (Level 2 or Level 3)
    let activeSubTabItem = null;
    let activeInnerMenuItem = null;
    if (activeOuterMenu && activeOuterMenu.innerMenu) {
        for (const inner of activeOuterMenu.innerMenu) {
            if (inner.subMenu) {
                const sub = inner.subMenu.find(s => location === s.to);
                if (sub) {
                    activeSubTabItem = sub;
                    activeInnerMenuItem = inner;
                    break;
                }
            }
            if (location === inner.to) {
                activeSubTabItem = inner;
                activeInnerMenuItem = inner;
                break;
            }
        }
    }

    const headerTitle = activeSubTabItem ? activeSubTabItem.Name : (activeOuterMenu ? activeOuterMenu.Name : "Dashboard");

    return (
        <div>
            <div ref={(el) => { if (el) checkPermission('Sidebar', { current: el }); }} id='{"tabname": "sidebar", "data": "sidebar_tab"}'>
                <main className="sk-dashboard-main vh-100">

                    {/* Backdrop Overlay on Mobile */}
                    <div
                        className={`sidebar-backdrop ${sidebarOpen ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    />

                    {/* Left Sidebar Drawer */}
                    <div
                        id='sidebar'
                        className={`sidebar-main vh-100 tempSide ${sidebarOpen ? 'show' : ''} ${(() => {
                            const showCol2 = sidebarOpen || isPinned;
                            const currentMenuForCol3 = hoveredMenu || ((showCol2 && !isPinned) ? activeOuterMenu : null);
                            const showCol3 = !!(currentMenuForCol3 && currentMenuForCol3.innerMenu && currentMenuForCol3.innerMenu.length > 0);

                            if (showCol2) {
                                return showCol3 ? "w-548 show-col2 show-col3" : "w-308 show-col2";
                            } else {
                                return showCol3 ? "w-308 show-col3" : "w-68";
                            }
                        })()}`}
                        onMouseLeave={() => {
                            handleSidebarMouseLeave();
                            setHoveredMenu(null);
                        }}
                    >
                        {/* Column 1: Slim Icon Bar */}
                        <div className="sidebar-col-1">
                            {/* Small Logo / Icon at top */}
                            <div className="col1-logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '0px', padding: '0 8px' }}>
                                <img src="./assets/logo.png" alt="logo" style={{ width: '28px', height: '28px' }} />
                            </div>
                            {sortableItems.map((val) => {
                                if (!val.isPermitted) return null;
                                const isL1Active = activeOuterMenu?.to === val.to;
                                return (
                                    <div
                                        key={val.id}
                                        className={`col1-icon-btn ${isL1Active ? 'active' : ''}`}
                                        onClick={(e) => {
                                            if (!block) {
                                                handleMenuItemClickWithExpand(val, e);
                                            } else {
                                                handleBlockUI();
                                            }
                                        }}
                                        onMouseEnter={() => setHoveredMenu(val)}
                                        title={val.Name}
                                    >
                                        {val.icon && <i className={val.icon} />}
                                    </div>
                                );
                            })}
                        </div>

                        {/* Column 2: Main Sidebar Menu */}
                        <div className="sidebar-col-2">
                            {/* Header with full logo and pin button */}
                            <div className="sidebar-logo-head overflow-hidden" style={{ borderBottom: 'none', padding: '0 8px 10px 8px', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Link to="/employee-dashboard" className="srkaycg-logo d-inline-block">
                                    <img
                                        className="full-logo"
                                        src={theme === 'dark' ? './assets/srkay-logo-dark.png' : './assets/srkay-logo-light.png'}
                                        alt="srkaycg-logo"
                                        style={{ width: '90px',  height: 'auto', objectFit: 'contain' }}
                                    />
                                </Link>
                                <div className={`pin-btn ${isPinned ? 'pinned' : ''}`} onClick={togglePin}>
                                    <FontAwesomeIcon icon={faThumbtack} style={{ fontSize: '14px' }} />
                                </div>
                            </div>

                            <div className="col2-menu-list">
                                {sortableItems.map((val) => {
                                    if (!val.isPermitted) return null;
                                    const isL1Active = activeOuterMenu?.to === val.to;
                                    const isL1Hovered = hoveredMenu?.to === val.to;
                                    const isConfigSubs = val.innerMenu && val.innerMenu.length > 0;
                                    return (
                                        <div
                                            key={val.id}
                                            onMouseEnter={() => setHoveredMenu(val)}
                                        >
                                            <Link
                                                to={val.to || "#"}
                                                 state={val?.state}
                                                className={`col2-menu-item ${isL1Active ? 'active' : ''} ${isL1Hovered ? 'hovered' : ''}`}
                                                onClick={(e) => {
                                                    if (!block) {
                                                        handleMenuItemClickWithExpand(val, e);
                                                    } else {
                                                        handleBlockUI();
                                                    }
                                                }}
                                                style={{ pointerEvents: val.isDisabled ? 'none' : 'auto', opacity: val.isDisabled ? 0.4 : 1 }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    {val.icon && <i className={val.icon} style={{ fontSize: '16px' }} />}
                                                    <span>{val.Name}</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {isConfigSubs && (
                                                        <FontAwesomeIcon icon="fa-solid fa-plus" style={{ fontSize: '11px', opacity: 0.6 }} />
                                                    )}
                                                    {val.notification_count > 0 && (
                                                        <span className="sidebar-badge">{val.notification_count}</span>
                                                    )}
                                                </div>
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Column 3: Inner Flyout Navigation Panel */}
                        {(() => {
                            const showCol2 = sidebarOpen || isPinned;
                            const currentMenuForCol3 = hoveredMenu || ((showCol2 && !isPinned) ? activeOuterMenu : null);
                            const hasCol3 = currentMenuForCol3 && currentMenuForCol3.innerMenu && currentMenuForCol3.innerMenu.length > 0;
                            if (!hasCol3) return null;
                            return (
                                <div className="sidebar-col-3">
                                    <div className="col3-header" style={{ padding: '0 4px 12px 4px', fontSize: '13px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        <span>{currentMenuForCol3.Name}</span>
                                    </div>
                                    <div className="col3-search-container">
                                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            value={col3Search}
                                            onChange={(e) => setCol3Search(e.target.value)}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        {(() => {
                                            if (sidebarSubmenuMode === 'sameLevel') {
                                                const flatList = [];
                                                currentMenuForCol3.innerMenu.forEach((inner) => {
                                                    if (!inner.isPermitted) return;
                                                    const hasL3 = inner.subMenu && inner.subMenu.length > 0;
                                                    if (hasL3) {
                                                        inner.subMenu.forEach((sub) => {
                                                            if (!sub.isPermitted) return;
                                                            flatList.push(sub);
                                                        });
                                                    } else {
                                                        flatList.push(inner);
                                                    }
                                                });

                                                return flatList
                                                    .filter(item => !col3Search || item.Name.toLowerCase().includes(col3Search.toLowerCase()))
                                                    .map((item, idx) => {
                                                        const isActive = location === item.to;
                                                        const colors = ["dot-purple", "dot-green", "dot-pink", "dot-blue", "dot-orange"];
                                                        const dotClass = colors[idx % colors.length];

                                                        return (
                                                            <div key={`col3-flat-${item.to || ''}-${item.Name}-${idx}`} className="col3-l2-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <Link
                                                                    to={item.to}
                                                                    state={item?.state}
                                                                    className={`col3-menu-item col3-l2-item ${isActive ? 'active' : ''}`}
                                                                    style={{ pointerEvents: item.isDisabled ? 'none' : 'auto', opacity: item.isDisabled ? 0.4 : 1 }}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <span className={`dot ${dotClass}`} />
                                                                        <span>{item.Name}</span>
                                                                    </div>
                                                                    {item.notification_count > 0 && (
                                                                        <span className="sidebar-badge">{item.notification_count}</span>
                                                                    )}
                                                                </Link>
                                                            </div>
                                                        );
                                                    });
                                            } else {
                                                return currentMenuForCol3.innerMenu
                                                    .filter(inner => {
                                                        const matchesSelf = !col3Search || inner.Name.toLowerCase().includes(col3Search.toLowerCase());
                                                        const matchesSub = inner.subMenu && inner.subMenu.some(sub => sub.Name.toLowerCase().includes(col3Search.toLowerCase()));
                                                        return matchesSelf || matchesSub;
                                                    })
                                                    .map((inner, idx) => {
                                                        if (!inner.isPermitted) return null;
                                                        const isL2Active = activeInnerMenuItem?.to === inner.to;
                                                        const hasL3 = inner.subMenu && inner.subMenu.length > 0;
                                                        const colors = ["dot-purple", "dot-green", "dot-pink", "dot-blue", "dot-orange"];
                                                        const dotClass = colors[idx % colors.length];

                                                        return (
                                                            <div key={`col3-l2-${inner.to || ''}-${inner.Name}-${idx}`} className="col3-l2-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <Link
                                                                    to={inner.to}
                                                                    state={inner?.state}
                                                                    className={`col3-menu-item col3-l2-item ${isL2Active ? 'active' : ''}`}
                                                                    style={{ pointerEvents: inner.isDisabled ? 'none' : 'auto', opacity: inner.isDisabled ? 0.4 : 1 }}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <span className={`dot ${dotClass}`} />
                                                                        <span>{inner.Name}</span>
                                                                    </div>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        {inner.notification_count > 0 && (
                                                                            <span className="sidebar-badge">{inner.notification_count}</span>
                                                                        )}
                                                                        {hasL3 && (
                                                                            <i
                                                                                className={collapsedSubmenus[inner.to || inner.Name] ? "fa-solid fa-angle-right" : "fa-solid fa-angle-down"}
                                                                                style={{ fontSize: '11px', opacity: 0.8, cursor: 'pointer', padding: '4px' }}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    setCollapsedSubmenus(prev => ({
                                                                                        ...prev,
                                                                                        [inner.to || inner.Name]: !prev[inner.to || inner.Name]
                                                                                    }));
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </Link>

                                                                {hasL3 && !collapsedSubmenus[inner.to || inner.Name] && (
                                                                    <div className="col3-l3-list">
                                                                        {inner.subMenu.map((sub, sIdx) => {
                                                                            if (!sub.isPermitted) return null;
                                                                            const isL3Active = location === sub.to;
                                                                            return (
                                                                                <Link
                                                                                    key={`col3-l3-${sub.to || ''}-${sub.Name}-${sIdx}`}
                                                                                    to={sub.to}
                                                                                    state={sub?.state}
                                                                                    className={`col3-l3-item ${isL3Active ? 'active' : ''}`}
                                                                                    style={{ pointerEvents: sub.isDisabled ? 'none' : 'auto', opacity: sub.isDisabled ? 0.4 : 1 }}
                                                                                >
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                        {sub.icon && <i className={sub.icon}  />}
                                                                                        <span>{sub.Name}</span>
                                                                                    </div>
                                                                                    {sub.notification_count > 0 && (
                                                                                        <span className="sidebar-badge">{sub.notification_count}</span>
                                                                                    )}
                                                                                </Link>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    });
                                            }
                                        })()}
                                    </div>
                                </div>
                            );
                        })()}
                    </div>

                    {/* Right Panel Main Content Area */}
                    <div className={`sk-content-wrapper ${isPinned ? 'pinned' : ''}`}>
                        <div>
                            <Dialog className='modal-large' visible={viewProfileDialog} onHide={() => setViewProfileDialog(false)} draggable={false} header="My Profile">
                                <Profile feedBackData={feedBackData} />
                            </Dialog>
                        </div>
                        <Dialog className='modal-medium' visible={carouselPopup} onHide={() => setCaroselPopup(false)} draggable={false} header="Carousel Images">
                            <CarouselImage />
                        </Dialog>

                        <div className="sidebartab">

                            {/* Modern Header Row matching the mockup image */}
                            <header className="sk-header-bar-mockup">
                                <div className="sk-header-left">
                                    {/* Launcher Menu Toggle Button */}
                                    <button
                                        className="sk-launcher-btn"
                                        onClick={() => setShowMegaMenu(!showMegaMenu)}
                                        title="App Launcher"
                                        style={{ marginRight: '8px', marginLeft: 0 }}
                                    >
                                        <FontAwesomeIcon icon={faGrip} />
                                    </button>

                                    <div className="sk-title-stack">
                                        <span className="sk-title-subtitle">SRKAY Insights</span>
                                        <h1 className="sk-title-main">{headerTitle}</h1>
                                    </div>
                                </div>

                                {/* Center Tab Container */}
                                <div className="sk-header-center-tabs" style={{ maxWidth: '65%' }}>
                                    {/* Desktop Tab System */}
                                    <div className="sk-header-tabs-desktop-group" style={{ width: '100%' }}>
                                        {/* Main Tabs (Level 1) */}
                                        {openTabs.length > 0 && (
                                            tabViewMode === 'flat' ? (
                                                <div className="sk-flat-tabs-scroll-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '6px', maxWidth: '100%', position: 'relative' }}>
                                                    {hasScrollOverflow && (
                                                        <button
                                                            onClick={() => handleScrollTabs('left')}
                                                            className="sk-flat-tabs-scroll-btn btn-left"
                                                            style={{
                                                                background: 'transparent',
                                                                border: 'none',
                                                                color: 'var(--text-color)',
                                                                cursor: 'pointer',
                                                                padding: '4px',
                                                                opacity: 0.7,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faChevronLeft} />
                                                        </button>
                                                    )}

                                                    <div
                                                        ref={flatTabsContainerRef}
                                                        className="sk-header-tabs-capsule"
                                                        style={{ overflowX: 'auto', whiteSpace: 'nowrap', maxWidth: '100%', scrollbarWidth: 'none', msOverflowStyle: 'none', scrollBehavior: 'smooth' }}
                                                    >
                                                        {(() => {
                                                            const list = [];
                                                            openTabs.forEach((val) => {
                                                                if (!val.isPermitted) return;
                                                                const openSubs = openSubTabs[val.to] || [];
                                                                const isMainActive = location === val.to ||
                                                                    (val.checkPath && val.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)) && openSubs.every(s => location !== s.to));

                                                                if (openSubs.length === 0) {
                                                                    list.push({
                                                                        type: 'main',
                                                                        tab: val,
                                                                        parentTo: val.to,
                                                                        active: isMainActive
                                                                    });
                                                                }

                                                                openSubs.forEach((subVal) => {
                                                                    if (!subVal.isPermitted) return;
                                                                    list.push({
                                                                        type: 'sub',
                                                                        tab: subVal,
                                                                        parentTo: val.to,
                                                                        active: location === subVal.to
                                                                    });
                                                                });
                                                            });

                                                            return list.map((item, index) => {
                                                                const val = item.tab;
                                                                const active = item.active;
                                                                const isSub = item.type === 'sub';

                                                                return (
                                                                    <div
                                                                        key={`${item.parentTo}-${val.to || index}`}
                                                                        className="sk-tab-flat-item-wrapper"
                                                                        style={{ pointerEvents: val.isDisabled ? 'none' : 'auto', opacity: val.isDisabled ? 0.4 : 1, position: 'relative', display: 'inline-flex', alignItems: 'center', padding: '0 4px' }}
                                                                    >
                                                                        {active ? (
                                                                            <div className="sk-tab-item-active-pill">
                                                                                {val.icon && <i className={val.icon} />}
                                                                                <span>{val?.Name}</span>
                                                                                <i
                                                                                    className="srkay-close"
                                                                                    style={{ marginLeft: '6px', cursor: 'pointer', fontSize: '10px', fontWeight: 'bold' }}
                                                                                    onClick={(e) => {
                                                                                        if (isSub) {
                                                                                            handleCloseSubTab(item.parentTo, val, e);
                                                                                        } else {
                                                                                            handleCloseTab(val, e);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                {val?.notification_count > 0 && (
                                                                                    <span className="badge-tab-count" style={{ position: 'static', marginLeft: '4px' }}>
                                                                                        {val.notification_count}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <Link
                                                                                    className="sk-tab-item-flat-inactive"
                                                                                    to={val?.to}
                                                                                    state={val?.state}
                                                                                    onClick={(e) => {
                                                                                        if (!isSub) {
                                                                                            handleTabClick(val, e);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    {val.icon ? (
                                                                                        <i className={val.icon} />
                                                                                    ) : (
                                                                                        <span className="sk-tab-flat-fallback-letter">
                                                                                            {val.Name ? val.Name.charAt(0).toUpperCase() : '?'}
                                                                                        </span>
                                                                                    )}
                                                                                </Link>
                                                                                <span className="sk-tab-flat-tooltip-text">{val?.Name}</span>
                                                                                <i
                                                                                    className="srkay-close sk-tab-flat-close-btn"
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '8px',
                                                                                        position: 'absolute',
                                                                                        top: '-2px',
                                                                                        right: '-2px',
                                                                                        background: theme === 'dark' ? '#2a2b2f' : '#ffffff',
                                                                                        border: '1px solid var(--grid-border-color)',
                                                                                        borderRadius: '50%',
                                                                                        width: '12px',
                                                                                        height: '12px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        boxShadow: 'var(--shadow-sm)',
                                                                                        color: 'var(--text-color)'
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        if (isSub) {
                                                                                            handleCloseSubTab(item.parentTo, val, e);
                                                                                        } else {
                                                                                            handleCloseTab(val, e);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                {val?.notification_count > 0 && (
                                                                                    <span className="badge-tab-count" style={{ position: 'absolute', top: '-4px', right: '-4px', margin: 0 }}>
                                                                                        {val.notification_count}
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                );
                                                            });
                                                        })()}
                                                    </div>

                                                    {hasScrollOverflow && (
                                                        <button
                                                            onClick={() => handleScrollTabs('right')}
                                                            className="sk-flat-tabs-scroll-btn btn-right"
                                                            style={{
                                                                background: 'transparent',
                                                                border: 'none',
                                                                color: 'var(--text-color)',
                                                                cursor: 'pointer',
                                                                padding: '4px',
                                                                opacity: 0.7,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faChevronRight} />
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="sk-header-tabs-capsule">
                                                    {openTabs.map((val, index) => {
                                                        if (!val.isPermitted) return null;
                                                        const active = location === val.to ||
                                                            (val.checkPath && val.checkPath.split(' ').map(p => p.trim()).filter(Boolean).some(p => location.startsWith(p)));
                                                        const openSubs = openSubTabs[val.to] || [];
                                                        const hasOpenSubs = openSubs.length > 0;
                                                        const hasConfigSubs = val.innerMenu && val.innerMenu.length > 0;
                                                        return (
                                                            <div
                                                                key={val.to || index}
                                                                className="sk-tab-item-container"
                                                                style={{ pointerEvents: val.isDisabled ? 'none' : 'auto', opacity: val.isDisabled ? 0.4 : 1, position: 'relative' }}
                                                            >
                                                                {active ? (
                                                                    <div className="sk-tab-item-active-pill">
                                                                        {val.icon && <i className={val.icon} />}
                                                                        <span>{val?.Name}</span>
                                                                        {(!hasConfigSubs || !hasOpenSubs) && (
                                                                            <i
                                                                                className="srkay-close"
                                                                                style={{ marginLeft: '6px', cursor: 'pointer', fontSize: '10px', fontWeight: 'bold' }}
                                                                                onClick={(e) => handleCloseTab(val, e)}
                                                                            />
                                                                        )}
                                                                        {val?.notification_count > 0 && (
                                                                            <span className="badge-tab-count" style={{ position: 'static', marginLeft: '4px' }}>
                                                                                {val.notification_count}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <Link
                                                                        className="sk-tab-item-inactive-icon"
                                                                        to={val?.to}
                                                                        state={val?.state}
                                                                        onClick={(e) => handleTabClick(val, e)}
                                                                        title={val.Name}
                                                                    >
                                                                        {val.icon && <i className={val.icon} />}
                                                                        {(!hasConfigSubs || !hasOpenSubs) && (
                                                                            <i
                                                                                className="srkay-close"
                                                                                style={{ marginLeft: '4px', cursor: 'pointer', fontSize: '8px', opacity: 0.6 }}
                                                                                onClick={(e) => handleCloseTab(val, e)}
                                                                            />
                                                                        )}
                                                                        {val?.notification_count > 0 && (
                                                                            <span className="badge-tab-count" style={{ position: 'absolute', top: '-4px', right: '-4px', margin: 0 }}>
                                                                                {val.notification_count}
                                                                            </span>
                                                                        )}
                                                                    </Link>
                                                                )}

                                                                {/* Hover Submenu Dropdown displaying ONLY open sub-tabs */}
                                                                {hasOpenSubs && (
                                                                    <div className="sk-tab-hover-dropdown">
                                                                        <ul className="sk-hover-menu-list" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                                                            {openSubs.map((subVal, sIdx) => {
                                                                                if (!subVal.isPermitted) return null;
                                                                                const subActive = location === subVal.to;

                                                                                return (
                                                                                    <li key={subVal.to || sIdx} className={`sk-hover-menu-item ${subActive ? 'active' : ''}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 6px' }}>
                                                                                        <Link to={subVal.to} className="sk-hover-menu-link" style={{ flexGrow: 1 }} state={subVal?.state}>
                                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                                {subVal.icon && <i className={subVal.icon} />}
                                                                                                <span>{subVal.Name}</span>
                                                                                            </div>
                                                                                        </Link>
                                                                                        <i
                                                                                            className="srkay-close close-btn"
                                                                                            style={{ cursor: 'pointer', fontSize: '10px', marginLeft: '8px', padding: '4px' }}
                                                                                            onClick={(e) => handleCloseSubTab(val.to, subVal, e)}
                                                                                        />
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )
                                        )}
                                    </div>

                                    {/* Mobile/Responsive Dropdown Group */}
                                    {activeOuterMenu && openSubTabs[activeOuterMenu.to] && openSubTabs[activeOuterMenu.to].length > 0 && (
                                        <div className="sk-header-tabs-mobile-group sk-sub-tab-dropdown-container" style={{ position: 'relative' }}>
                                            <button
                                                className="sk-sub-tab-dropdown-trigger"
                                                onClick={() => setSubTabsDropdownOpen(!subTabsDropdownOpen)}
                                            >
                                                <i className={activeSubTabItem?.icon || activeOuterMenu.icon} style={{ marginRight: '8px' }} />
                                                <span>{activeSubTabItem ? activeSubTabItem.Name : activeOuterMenu.Name}</span>
                                                <i className={subTabsDropdownOpen ? "srkay-arrow-up" : "srkay-arrow-down"} style={{ marginLeft: '8px', fontSize: '10px' }} />
                                            </button>

                                            {subTabsDropdownOpen && (
                                                <div className="sk-sub-tab-dropdown-menu">
                                                    {openSubTabs[activeOuterMenu.to].map((subVal, sIdx) => {
                                                        if (!subVal.isPermitted) return null;
                                                        const subActive = location === subVal.to;
                                                        return (
                                                            <div
                                                                key={subVal.to || sIdx}
                                                                className={`sk-dropdown-tab-item ${subActive ? 'active' : ''}`}
                                                                onClick={() => {
                                                                    navigate(subVal?.to, { state: subVal?.state });
                                                                    setSubTabsDropdownOpen(false);
                                                                }}
                                                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    {subVal.icon && <i className={subVal.icon} />}
                                                                    <span>{subVal.Name}</span>
                                                                </div>
                                                                <i
                                                                    className="srkay-close close-btn"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleCloseSubTab(activeOuterMenu.to, subVal, e);
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Right Actions: Bell & User Info Card */}
                                <div className="sk-header-right">
                                    <button
                                        className="sk-action-btn-circle"
                                        onClick={() => {
                                            setShowNotification((prev) => ({ ...prev, visible: true }));
                                            getNotificationData();
                                            GetEmployeeAttandance(null, "widget");
                                        }}
                                    >
                                        <i className="icon-notification-outline" />
                                        {(notificationCount?.notifi + notificationCount?.punctuality) > 0 && (
                                            <div className="badge-notification-count" style={{ position: 'absolute', top: '-4px', right: '-4px' }}>
                                                {notificationCount?.notifi + notificationCount?.punctuality}
                                            </div>
                                        )}
                                    </button>

                                    <div
                                        className="sk-user-profile-section"
                                        onClick={() => setViewProfile(!viewProfile)}
                                        ref={profileIconRef}
                                    >
                                        <div className="sk-profile-avatar-circle">
                                            {profileImage && !profileImage.includes("grey-user-icon.png") ? (
                                                <img src={profileImage} alt="Profile" />
                                            ) : (
                                                <span>{getInitials(myProfileData?.user_display_name || myProfileData?.user_name)}</span>
                                            )}
                                        </div>
                                        <div className="sk-profile-text-stack">
                                            <span className="sk-profile-name">{myProfileData?.user_display_name || myProfileData?.user_name || "William John"}</span>
                                            <span className="sk-profile-role">{myProfileData?.employee_id || myProfileData?.user_code || ""}</span>
                                        </div>
                                    </div>
                                </div>
                            </header>

                            {/* Main Body Content Panel */}
                            <div className="sk-content-body" style={{ minHeight: '200px' }}>
                                <Content openTabs={openTabs} currentLayoutLocation={location} visitedPaths={visitedPaths} setVisitedPaths={setVisitedPaths} />
                            </div>
                        </div>

                        {/* Profile Dropdown Menu */}
                        {viewProfile &&
                            <div ref={profileDropdownRef} className="profile-dropdown">
                                <div onClick={() => { setViewProfileDialog(true); getMyProfile(); setViewProfile(false); }}>
                                    <FontAwesomeIcon icon={faUser} className='profile-dropdown-icon' />
                                    <span>Profile</span>
                                </div>
                                {
                                    !getValuePermission("employee_dashboard_tab") && <div onClick={() => { setShowTaptik(true); setViewProfile(false); }}>
                                        <FontAwesomeIcon icon={faThumbtack} className='profile-dropdown-icon' />
                                        <span>TapTik</span>
                                    </div>
                                }
                                {
                                    !getValuePermission("upload_carousel_images_btn") &&
                                    <div onClick={() => { setCaroselPopup(true); setViewProfile(false); }}>
                                        <FontAwesomeIcon icon={faCamera} className='profile-dropdown-icon' />
                                        <span>Carousel Images</span>
                                    </div>
                                }
                                <div onClick={(e) => { e.stopPropagation(); setAppPopup({ show: true }); setViewProfile(false); }}>
                                    <FontAwesomeIcon icon={faMobile} className='profile-dropdown-icon' />
                                    <span>App</span>
                                </div>
                                {
                                    !getValuePermission("theme_tab") && (
                                        <div
                                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '4px' }}
                                            onClick={(e) => { e.stopPropagation(); setShowMenu((prev) => ({ ...prev, theme: !prev?.theme })); }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <FontAwesomeIcon icon={faPalette} className='profile-dropdown-icon' />
                                                <span>Theme</span>
                                            </div>
                                            {showMenu?.theme && (
                                                <div className="theme-submenu">
                                                    <div onClick={(e) => { e.stopPropagation(); setTheme('light'); }}>
                                                        <span className={`radio-button ${theme === 'light' ? 'selected' : ''}`}></span>
                                                        <span>Light</span>
                                                    </div>
                                                    <div onClick={(e) => { e.stopPropagation(); setTheme('dark'); }}>
                                                        <span className={`radio-button ${theme === 'dark' ? 'selected' : ''}`}></span>
                                                        <span>Dark</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                                {
                                    !getValuePermission("toast_tab") && (
                                        <div
                                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '4px' }}
                                            onClick={(e) => { e.stopPropagation(); setShowMenu((prev) => ({ ...prev, toast: !prev?.toast })); }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                <FontAwesomeIcon icon={faMessage} className='profile-dropdown-icon' />
                                                <span>Toast</span>
                                            </div>
                                            {showMenu?.toast && (
                                                <div className="theme-submenu">
                                                    {toastPositions.map((pos) => (
                                                        <div
                                                            key={pos.id}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setPosition(pos?.position);
                                                            }}
                                                        >
                                                            <span className={`radio-button ${position === pos?.position ? 'selected' : ''}`}></span>
                                                            <span>{pos?.name}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                                {!getValuePermission("theme_tab") && <div onClick={resetSidebar} className='logout-button'>
                                    <FontAwesomeIcon icon={faBars} className='profile-dropdown-icon' />
                                    <span>Reset Sidebar</span>
                                </div>}
                                {platform === "local" && <div onClick={() => { setVisible(true); setViewProfile(false); }} className='logout-button'>
                                    <FontAwesomeIcon icon={faSignOutAlt} className='profile-dropdown-icon' />
                                    <span>Logout</span>
                                </div>
                                }
                            </div>
                        }

                        <CommanDialog visible={visible} message="Are you sure you want to logout?" handleClose={() => setVisible(false)} handleFun={() => handleLogout()} />

                        <Dialog
                            visible={showNotification?.visible}
                            onHide={() => { if (!block) { if (!_.isEmpty(notifiData)) { setShowNotification((prev) => ({ ...prev, confirmation: true })); } else { setShowNotification((prev) => ({ ...prev, visible: false })); } } }}
                            style={{ height: "80%" }}
                            className='modal-large'
                            draggable={false}
                            header={() => {
                                return (
                                    <div >
                                        <FontAwesomeIcon icon="fa-solid fa-bullhorn" /> Since you've been gone
                                    </div>
                                );
                            }}
                        >
                            <div style={{ height: "100%" }}>
                                <Inbox notifiData={notifiData} setNotifiData={setNotifiData} readData={readData} dataFlag={dataFlag} getNotificationData={getNotificationData} punctualityData={rowData} GetEmployeeAttandance={() => GetEmployeeAttandance(null, "widget")} GetEmployeeAttandanceSummary={() => GetEmployeeAttandanceSummary("widget")} />
                            </div>
                        </Dialog>

                        {showTaptik && <TaptikHistory showHistory={showTaptik} setShowHistory={setShowTaptik} userId={null} showTaptik={true} />}
                        <CommanDialog visible={showNotification?.confirmation} message="Are you sure you want to close the popup without reviewing the notification. Do you wish to proceed?" handleClose={() => setShowNotification((prev) => ({ ...prev, confirmation: false }))} handleFun={() => setShowNotification((prev) => ({ ...prev, confirmation: false, visible: false }))} />

                        {appPopup?.show && <DownloadApp downloadPopup={appPopup?.show} handleClose={() => { setAppPopup({ show: false, type: false }); }} deviceType={appPopup?.type} />}

                        {/* App Launcher Mega Menu Overlay */}
                        {showMegaMenu && (
                            <div className="sk-megamenu-overlay" onClick={() => setShowMegaMenu(false)}>
                                <div
                                    className="sk-megamenu-panel"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="sk-megamenu-header">
                                        <div className="sk-megamenu-search-wrapper">
                                            <FontAwesomeIcon icon={faMagnifyingGlass} className="sk-search-icon" />
                                            <input
                                                type="text"
                                                placeholder="Search modules, sections, and features..."
                                                value={megaMenuSearch}
                                                onChange={(e) => setMegaMenuSearch(e.target.value)}
                                                autoFocus
                                            />
                                        </div>
                                        <button className="sk-megamenu-close-btn" onClick={() => setShowMegaMenu(false)}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>

                                    <div className="sk-megamenu-scroll-wrapper">
                                        <div className="sk-megamenu-content">
                                            {sortableItems.map((val) => {
                                                if (!val.isPermitted) return null;

                                                const l2Filtered = val.innerMenu ? val.innerMenu.filter(inner => {
                                                    const matchesL2 = inner.Name.toLowerCase().includes(megaMenuSearch.toLowerCase());
                                                    const matchesL3 = inner.subMenu && inner.subMenu.some(sub => sub.Name.toLowerCase().includes(megaMenuSearch.toLowerCase()));
                                                    return matchesL2 || matchesL3;
                                                }) : [];

                                                const matchesL1 = val.Name.toLowerCase().includes(megaMenuSearch.toLowerCase());
                                                const showL1 = matchesL1 || l2Filtered.length > 0;

                                                if (megaMenuSearch && !showL1) return null;

                                                return (
                                                    <div key={val.id} className="sk-megamenu-card">
                                                        <div className="sk-megamenu-card-header">
                                                            {val.icon && <i className={val.icon} />}
                                                            <span>{val.Name}</span>
                                                        </div>
                                                        <div className="sk-megamenu-card-body">
                                                            {(megaMenuSearch ? l2Filtered : (val.innerMenu || [])).map((inner, idx) => {
                                                                if (!inner.isPermitted) return null;
                                                                const hasL3 = inner.subMenu && inner.subMenu.length > 0;
                                                                const l3Filtered = inner.subMenu ? inner.subMenu.filter(sub =>
                                                                    !megaMenuSearch || sub.Name.toLowerCase().includes(megaMenuSearch.toLowerCase())
                                                                ) : [];

                                                                return (
                                                                    <div key={`mega-l2-${inner.to || ''}-${inner.Name}-${idx}`} className="sk-megamenu-l2-section">
                                                                        <Link
                                                                            to={inner.to}
                                                                            state={inner?.state}
                                                                            className="sk-megamenu-l2-link"
                                                                            onClick={() => setShowMegaMenu(false)}
                                                                        >
                                                                            {inner.Name}
                                                                        </Link>
                                                                        {hasL3 && (
                                                                            <div className="sk-megamenu-l3-group">
                                                                                {(megaMenuSearch ? l3Filtered : inner.subMenu).map((sub, sIdx) => {
                                                                                    if (!sub.isPermitted) return null;
                                                                                    return (
                                                                                        <Link
                                                                                            key={`mega-l3-${sub.to || ''}-${sub.Name}-${sIdx}`}
                                                                                            to={sub.to}
                                                                                            state={sub?.state}
                                                                                            className="sk-megamenu-l3-link"
                                                                                            onClick={() => setShowMegaMenu(false)}
                                                                                        >
                                                                                            {sub.Name}
                                                                                        </Link>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default DefaultLayout;